import type { Metric } from "web-vitals";

export async function reportWebVitals() {
  if (import.meta.env.DEV) return;

  const { onCLS, onFCP, onLCP, onTTFB, onINP } = await import("web-vitals");

  const sendMetric = (metric: Metric) => {
    import("@sentry/react")
      .then((Sentry) => {
        Sentry.addBreadcrumb({
          category: "web-vital",
          message: `${metric.name}: ${metric.value}`,
          level: "info",
          data: {
            name: metric.name,
            value: metric.value,
            rating: metric.rating,
            delta: metric.delta,
            id: metric.id,
          },
        });
      })
      .catch(() => {});
  };

  onCLS(sendMetric);
  onFCP(sendMetric);
  onLCP(sendMetric);
  onTTFB(sendMetric);
  onINP(sendMetric);
}
